import { SET_MEDIA_SELECTED_DATA, ADD_TO_DATA_SELECTED_MEDIA, INDEX_DATA_SELECTED_MEDIA, DELETE_DATA_SELECTED_MEDIA } from "./interactionMedia.actionTypes";

const initialState = {
  dataMediaSelected: {},
  multiMediaSelected:[],
  indexSelectMedia: null,
};

export default function interaction(state = initialState, action: any) {
  switch (action.type) {
    case SET_MEDIA_SELECTED_DATA: {
      return {
        ...state,
        dataMediaSelected: action.payload,
      };
    }
    case ADD_TO_DATA_SELECTED_MEDIA: {
      return {
        ...state,
        multiMediaSelected: [...state.multiMediaSelected, ...action.payload],
      };
    }
    case INDEX_DATA_SELECTED_MEDIA: {
      return {
        ...state,
        indexSelectMedia: action.payload,
      };
    }
    case DELETE_DATA_SELECTED_MEDIA: {
      const updatedMultiMediaSelected = state.multiMediaSelected.filter(
        (object) => object !== action.payload
      );
      return {
        ...state,
        multiMediaSelected: updatedMultiMediaSelected,
        dataMediaSelected:updatedMultiMediaSelected
      };
    }
    default:
      return state;
  }
}
